const initialState = {};

const configureUser = (state = initialState, action) => {
  switch (action.type) {
    case 'updateCredential': {
      return {
        ...state,
        credential: action.credential,
      };
    }
    case 'updateInfo': {
      return {
        ...state,
        info: action.info,
      };
    }
    case 'updatePromoCode': {
      const info = {
        ...state.info,
        promoCode: action.promoCode,
      };
      return {
        ...state,
        info: info,
      };
    }
    case 'signOut': {
      let {credential} = state;
      credential = {
        ...credential,
        password: undefined,
      };
      return {
        ...state,
        credential: credential,
        info: undefined,
      };
    }
    default: {
      return state;
    }
  }
};

export default configureUser;



// WEBPACK FOOTER //
// ./src/reducers/user.js